import React, { Component } from 'react';

import helpers from '../helpers/index';
import images from '../configs/images';
import route_helper from '../route-helper';
import api_auth from '../api/authentication';

import * as action_auth from '../store/session/actions';
import { save_risk_settings } from '../store/patient/actions';
import qs from 'qs'
import { connect } from "react-redux";
import ErrorSummary from "../components/error-summary";
import ActivityIndicator from "../components/activity-indicator";
import settings from "../configs/settings";
import Cookie from 'js-cookie'
import {
  save_login_data
} from '../helpers/helper-login';

const EMR_LOGIN = true

class AuthenticateEMRPage extends Component {

    constructor(props) {
      super(props);
      this.state = {
       errorMessages: [],
       params:{}
      };

      this.handleLoginFail = this.handleLoginFail.bind(this);
      this.authenticateEmrUser = this.authenticateEmrUser.bind(this);
      this.authenticateSSO = this.authenticateSSO.bind(this);
      this.storeQueryParams = this.storeQueryParams.bind(this);
      this.navigateUser = this.navigateUser.bind(this);
      this.parseQueryParams = this.parseQueryParams.bind(this);
    }

    async componentDidMount() {
      helpers.setSiteTitle('EMR Integration');
      this.mounted = true;
      await this.authenticateEmrUser();
    }

    async componentWillUnmount() {
      this.mounted = false;
    }

    async authenticateEmrUser() {
      api_auth.clearTokens();
      this.setState({ loading: true });

      try {
        const query = this.parseQueryParams();
        const finalMrn = this.sanitizeMrn(query.mrn);

        sessionStorage.setItem('is_emr_session', true);
        if (query.access_token) {
          await this.authenticateWithAccessToken(query, finalMrn);
          return;
        }

        if (query.syslogin) {
          const loginType = await this.getLoginType(query.syslogin);

          if (loginType === 'saml') {
            await this.authenticateWithSaml(query, finalMrn);
            return;
          }
          if (loginType === 'oauth') {
            await this.authenticateSSO(query, finalMrn);
            return;
          }
        }

        await this.authenticateWithUuidToken(query, finalMrn);

      } catch (error) {
        this.handleLoginFail('Error logging in. Contact your administrator.');
      } finally {
        if (this.mounted) {
          this.setState({ loading: false });
        }
      }
    }

    parseQueryParams() {
      return qs.parse(this.props.location.search, {
        ignoreQueryPrefix: true
      });
    }

    sanitizeMrn(mrn) {
      if (!mrn) return '';

      let cleanMrn = JSON.stringify(mrn);
      cleanMrn = cleanMrn.replace(/['"]+/g, '');

      const indexOfBackslash = cleanMrn.indexOf('\\');
      return indexOfBackslash >= 0 ? cleanMrn.slice(0, indexOfBackslash) : cleanMrn;
    }

    async getLoginType(syslogin) {
      try {
        const response = await api_auth.login_type_check(syslogin, EMR_LOGIN);
        return response;
      } catch (error) {
        console.log(error.stack);
        return null;
      }
    }

    async authenticateWithAccessToken(query, finalMrn) {
      try {
          const userData = await api_auth.verify_access_token(query.access_token, EMR_LOGIN);
          save_login_data(this.props.session.user, userData, this.props.dispatch);
          await this.props.dispatch(action_auth.authenticated(true))
          this.navigateUser(query.fname, query.lname, query.dob, finalMrn, query.data, query.signature);
        } catch (error) {
          console.error('authenticateWithAccessToken error:', error);
          this.handleLoginFail('Error logging in with access token. Contact your administrator.');
      }
    }

    async authenticateWithSaml(query, finalMrn) {
      const response = await api_auth.saml_login(query.syslogin);
      this.storeQueryParams(query, finalMrn);
      window.open(response['redirect_url'], '_self');
    }

    async authenticateWithUuidToken(query, finalMrn) {
      const UUID = query.token;
      const payload = await api_auth.authenticateEmrUser(UUID);

      const userData = this.buildUserDataFromPayload(payload);
      this.props.dispatch(action_auth.user_save(userData));
      this.props.dispatch(action_auth.authenticated(true));
      this.navigateUser(query.fname, query.lname, query.dob, finalMrn, query.data, query.signature);
    }

    buildUserDataFromPayload(payload) {
      const isAdmin = payload.account.access_type === 'admin';
      const isReadOnly = payload.account.access_type === 'read_only';
      const hasReadOnlyAccess = isReadOnly || payload.account.has_read_only_role || payload.account.has_deidentified_role;

      return {
        clinician_id: payload.organization.clinician_id,
        account_id: payload.account.account_id,
        staff_id: payload.account.staff_id,
        user_id: payload.profile.user_id,
        first_name: payload.profile.first_name,
        last_name: payload.profile.last_name,
        email: payload.profile.email,
        username: payload.profile.username,
        admin: isAdmin,
        account_type: payload.organization.org_type,
        organization_id: payload.organization.id,
        risk_model_years: payload.organization.risk_model_years,
        criteria_source_category_settings: payload.criteria_source_category_settings,
        criteria_source_categories: payload.criteria_source_categories,
        dial_code: payload.organization.dial_code,
        read_only: hasReadOnlyAccess,
        emr_always_read_only: payload.organization.emr_always_read_only,
        has_read_only_role: hasReadOnlyAccess,
        has_deidentified_role: payload.account.has_deidentified_role,
        login_type: payload.account.login_type,
        auto_logout_time: payload.account.auto_logout_time || 15,
        default_partner_view: payload.organization.default_partner_view,
        max_number_of_pedigrees: payload.organization.max_number_of_pedigrees,
      };
    }

    storeQueryParams(query, finalMrn) {
      if(query.data){
        localStorage.setItem('signature', query.signature)
        localStorage.setItem('encryptedData', query.data)

      }else{
        localStorage.setItem('fname', query.fname)
        localStorage.setItem('lname', query.lname)
        localStorage.setItem('dob', query.dob)
        localStorage.setItem('finalMrn', finalMrn)
      }
    }


    async authenticateSSO(query, finalMrn) {
      this.setState({ loading: true });
      api_auth.clearTokens();
      this.storeQueryParams(query, finalMrn);

      try {
        const response = await api_auth.get_oauth_redirect(query.syslogin);
        Cookie.set('OAuth', response['state']);
        window.open(response['url'], '_self');
      } catch (error) {
        this.handleLoginFail('Error logging in. Contact your administrator.');
      } finally {
        if (this.mounted) {
          this.setState({ loading: false });
        }
      }
    }

  navigateUser(firstName, lastName, dob, mrn, encryptedData, signature) {
    const basePath = '/emr_patients';
  
    const queryParams = encryptedData
      ? { signature, data: encryptedData }
      : { fname: firstName, lname: lastName, dob, mrn };

    const queryString = qs.stringify(queryParams);
    const fullPath = `${basePath}?${queryString}`;

    // Delay navigation to allow Redux state to propagate to route guards
     this.props.history.replace(fullPath);
  }
    handleLoginFail(error) {
      this.setState({errorMessages: [error]});
    }

    render() {
      const copyright_year = new Date().getFullYear();
      return (
        <React.Fragment>
          <div className="login_wrapper">
            <div className="animate form login_form">
              <section className="login_content">
                <ErrorSummary errorMessages={this.state.errorMessages} />
                  <div className="logo">
                      <img src={images.famhisLogo} className="img-responsive" alt="FamGenix Logo" />
                  </div>
                  <div className="animate form login_form">
                    <div><p className="text-center text-muted margin-nine-top"><span>&copy; {copyright_year} by FamHis, Inc. All rights reserved.</span></p></div>
                  </div>
              </section>
            </div>
          </div>
        <ActivityIndicator loading={this.state.loading} />

        </React.Fragment>
      );
    }
  }
  const redux_state = state => ({
    session: state.session
  });

  const redux_actions = dispatch => ({
    dispatch: (action) => dispatch(action)
  });

  export default connect(redux_state, redux_actions)(AuthenticateEMRPage);
